exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#myImg{border-radius:5px;cursor:pointer;transition:.3s;max-width:100%;max-height:100%}", ""]);

// exports
